import { flatMap } from 'lodash';
import { IFilterState } from '../../store/filters/model';
import { getBackendLocationId } from '../../utils/regions';
import { IBannerData as IBanner, IPikData } from '../../../typings/api';

export type Banners = {
  [key: number]: IBanner[];
};

export function mapBannersForRegion([filters, banners]: [IFilterState, Banners]): IBanner[] {
  const { query } = filters;
  const regionName = typeof query.region === 'number' || query.region === 'any' ? 'moscow' : query.region;

  const regionId = typeof query.region === 'number' ? query.region : getBackendLocationId(regionName);

  return banners[regionId];
}

export function mapBannersData(pikData: IPikData): Banners {
  const {
    data: { bannerObjects, locations },
  } = pikData;

  const locationsIds = locations.map(location => location.locationId);
  let regionsObjectWithBanners: { [key: number]: IBanner[] } = {};

  locationsIds.forEach(
    id =>
      (regionsObjectWithBanners[id] = flatMap(
        flatMap(locations.filter(location => location.locationId === id).map(location => location.bannerIds || [])),
        bannerId => bannerObjects.filter(banner => Number(banner.id) === bannerId),
      )),
  );

  return regionsObjectWithBanners;
}
